import { render } from "./loading.vue?vue&type=template&id=c6b5d8f4&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=c6b5d8f4&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b5d8f4"]])

export default __exports__